import { useEffect } from "react";
import { Button, Dialog, DialogContent } from "@core/components/ui";
import { useDialog } from "@core/components/dialog/hooks/useDialog";
import { cn } from "@core/utils";

export default function LayerAccountRegister() {
  const { isOpen, open, toggle } = useDialog({ type: "dialog", name: "registerAccount" });

  // 초기 마운트 발생 시에만 실행
  useEffect(() => {
    open();
  }, []);

  return (
    <Dialog open={isOpen} onOpenChange={toggle}>
      <DialogContent className={cn("lg:w-[600px]")} showCloseButton={false} useOutsideCloseOverlay={false}>
        <div>
          <div className={cn("mt-[50px] text-center text-[18px] font-bold text-gray-800 lg:text-[24px]")}>PLAYNC 계정으로 모든 사업장을 한 번에 관리하세요.</div>

          <div className={cn("mt-[40px] text-center text-gray-800", "text-[13px]", "lg:text-[16px]")}>
            NC Family ZONE 서비스 개선에 따라 PLAYNC 계정으로 편리하게 NC Family
            <br />
            ZONE을 이용하도록 변경되었습니다. 이제 하나의 PLAYNC 계정으로
            <br />
            모든 사업장을 편하게 관리할 수 있습니다.
          </div>

          <div className={cn("mt-[40px] text-center text-gray-800", "text-[13px]", "lg:text-[16px]")}>가입하기 버튼을 누르면 약관동의 페이지로 이동합니다.</div>

          <div className={cn("text-center", "mt-[20px]", "lg:mt-[40px]")}>
            <Button size="large" variant="bgPoint600" asChild>
              <a href="/account/register">가입하기</a>
            </Button>

            <Button size="large" variant="borderBgWhite" className={cn("ml-[10px]")} asChild>
              <a href="https://pcbang.plaync.com/board/notice/view?articleId=68b6e907b1c1d326956ef088">공지 확인하기</a>
            </Button>
          </div>

          <div className={cn("text-center text-gray-400", "mt-[50px] text-[13px]", "lg:mt-[40px] lg:text-[14px]")}>*가입한 PLAYNC 계정은 변경이 불가능합니다.</div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
